export default __webpack_public_path__ + "static/media/arrowUp.7f6c062d.svg";